<script>
    import { Bar } from 'vue-chartjs'

    export default {
        extends: Bar,
        props: ['chartdata', 'options','dataname'],
        mounted () {
            Chart.defaults.global.legend.display = false;
            this.renderChart({
                labels: this.chartdata,
                datasets: [
                    {
                        label: this.dataname,
                        backgroundColor: '#507CD6',
                        data: this.options,
                    }
                ]
            }, { responsive: true, maintainAspectRatio: false })
        }
    }
</script>

<style scoped>



</style>
